import React, { Component } from 'react';
import debounce from 'lodash/debounce';

/**
 * HOC to debounce a single prop.
 * Useful for instance when fetching is done reactively based on url
 * @param propName prop to debounce
 * @param wait time to debounce
 */
const debounceProp = (propName, wait = 250) =>
  WrappedComponent =>
    class extends Component {
      constructor(props) {
        super(props);
        this.state = {
          [propName]: props[propName],
        };
      }

      componentWillReceiveProps(nextProps) {
        if (this.props[propName] !== nextProps[propName]) {
          this.setProp(nextProps[propName]);
        }
      }

      setProp = debounce(value => this.setState({ [propName]: value }), wait);

      render() {
        return (
          <WrappedComponent
            {...this.props}
            {...this.state}
          />
        );
      }
    };

export default debounceProp;
